import React, { Component, useState, useEffect, useRef } from 'react';
import {
  useNavigate,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../../i18n";

import { fullCountries } from '../../../utils';

import Select from 'react-select';

import { TextInput, Image, View, Text, ActivityIndicator} from "react-native-web";

import HamburgerMenu from 'react-hamburger-menu';

import { Gradient } from 'react-gradient';

import Hls from 'hls.js';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';


import { ParallaxProvider, ParallaxBanner, Parallax } from 'react-scroll-parallax';
import { AnimatePresence, motion, useScroll, useTransform, useMotionValue } from 'framer-motion';




import AutoResizeText from './AutoResizeText';

import { Document, Page } from 'react-pdf';

import MyLoadingComponent from './MyLoadingComponent';

import HeaderPC from "../../header/HeaderPC";

import { pdfjs } from 'react-pdf';


pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const algoliasearch = require('algoliasearch');
var client = algoliasearch('HKB157K3KU', '357f2b37e5ef8c12f7b90877758ff663');


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

const words = ['Refonder', 'Réinventer', 'Réinitialiser', 'Reconstruire', 'Rebâtir', 'Réformer', 'Réorganiser', 'Réécrire', 'Réenraciner',  'Revitaliser', 'Réveiller', 'Réanimer', 'Ressusciter', 'Régénérer', 'Redéfinir', 'Réclamer', 'Revaloriser', 'Réhabiliter', 'Réconcilier'];


function convertDate(dateISO) {
  const date = new Date(dateISO);

  const formatted = new Intl.DateTimeFormat('fr-FR', {
    weekday: 'long',  // jour de la semaine
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(date);
  return formatted;
}

const contributionOptions = [{value: 'Time', label: 'Du temps (disponibilité régulière ou ponctuelle)'}, {value: 'Expertise', label: 'Mon expertise professionnelle'}, {value: 'Idea', label: 'Mes idées / réflexions stratégiques'},
                             {value: 'Communication_skills', label: 'Mes compétences en communication / médias'}, {value: 'IT_skills', label: 'Mes compétences techniques (web, IT, etc.)'}, {value: 'Field_experience', label: 'Mon expérience terrain / communautaire'},
                             {value: 'Network', label: 'Mon réseau (personnes, structures, partenaires…)'}, {value: 'Logistics', label: 'Un espace physique ou logistique (salle, matériel...)'}, {value: 'Leadership', label: 'Ma capacité d’écoute et de mobilisation'},
                             {value: 'Organization_skills', label: 'Mes compétences en organisation d’événements'}, {value: 'Energy', label: 'Mon énergie et ma motivation'}, {value: 'Dont_know', label: 'Je ne sais pas encore, mais je veux contribuer'},
                           ];
const organizationContributionOptions = [{value: 'Time', label: 'Du temps (disponibilité régulière ou ponctuelle)'}, {value: 'Expertise', label: 'Notre expertise professionnelle'}, {value: 'Idea', label: 'Nos idées / réflexions stratégiques'},
                             {value: 'Communication_skills', label: 'Nos compétences en communication / médias'}, {value: 'IT_skills', label: 'Nos compétences techniques (web, IT, etc.)'}, {value: 'Field_experience', label: 'Notre expérience terrain / communautaire'},
                             {value: 'Network', label: 'Notre réseau (personnes, structures, partenaires…)'}, {value: 'Logistics', label: 'Un espace physique ou logistique (salle, matériel...)'}, {value: 'Leadership', label: 'Notre capacité d’écoute et de mobilisation'},
                             {value: 'Organization_skills', label: 'Nos compétences en organisation d’événements'}, {value: 'Energy', label: 'Notre énergie et notre motivation'}, {value: 'Dont_know', label: 'Nous ne savons pas encore, mais nous voulons contribuer'},
                           ];

class OpenJobFormPCCreative extends Component {

    constructor(props) {

          super(props);

          this.formDivRef = React.createRef();
          this.formContainerRef = React.createRef();





   	   this.state = {
         contributions: [],
         contributionOptions: contributionOptions,
         organizationContributionOptions: organizationContributionOptions,
         countryOptions: [],
         selectedCountryOption: null,
         regionOptions: [],
         selectedRegionOption: {value: 'CD-KN', label: 'Kinshasa'},
         firstName: '',
         lastName: '',
         email: '',
         phone: '',
         region: '',
         role: '',
         infos: '',
         companyName: '',
         selectedSizeOption: null,
         sizeOptions: [{label: '1-10', value: '1-10'}, {label: '11-50', value: '11-50'}, {label: '51-100', value: '51-100'}, {label: '101-500', value: '101-500'}, {label: '501-1000', value: '501-1000'}, {label: '>1000', value: '>1000'}],
         editProfileStep: 1,
         profileCateg: null,
				 processing: false,
				 status: 'init',
		     currentYear: new Date().getFullYear()
   	   };

     }


		componentDidMount(){
         window.addEventListener('resize', this.handleResize);
        this.handleResize(); // initialize on mount
        this.loadCountries();
        this.loadRegions();



      /*  var ip = 'https://api2.debyoo.com/'; //generateIPForREST();


        fetch(ip+'delete_rerdc_sr_api', {
                                method: 'POST',
                                headers: {
                                  'Accept': 'application/json',
                                  'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                  id: '685196b7e3d16c4acde4cf0c'
                                })
           })
         .then((response) => response.json())
         .then((responseData) => {
             console.log('>> delete_rerdc_sr_api >> ' + JSON.stringify(responseData));

         })
          .catch(function(error) {

          }.bind(this)); */



	  }

	  componentWillMount(){

	  }

	 componentWillUnmount(){
      window.removeEventListener('resize', this.handleResize);

	  }

    loadRegions() {
          var index = client.initIndex('Regionname');


          index
          .search('*',
          {
            page: 0,
            filters: `country:CD`
          })
          .then(({ hits, nbPages, page, nbHits }) =>
          {

                if (nbHits > 0)
                {
                  const transformedArray = hits.map(item => ({
                    value: item.iso_state_code,
                    label: item.name
                  }));

                  this.setState({
                    regionOptions: transformedArray
                  })
                }
           });
    }


    loadCountries() {
         var _countries = [], _countryOptions = [];

          for (let i = 0; i < fullCountries().length; i++)
          {
                let c = fullCountries()[i];

                if (i18n.language == "fr")
                {
                      if (c.official_name_fr !== "")
                      {
                          var _obj = {
                            value: c.iso_2, label: c.official_name_fr
                          };

                          _countries.push(_obj);
                      }
                }
                else if (i18n.language == "en")
                {
                    if (c.official_name_en !== "")
                    {
                        var _obj = {
                          value: c.iso_2, label: c.official_name_en
                        };

                        _countries.push(_obj);
                    }
                }

                if (i == fullCountries().length-1)
                {

                        _countryOptions = _countries.sort((a,b) => a.label.localeCompare(b.label));

                        var _elemIndex = _countryOptions.findIndex(obj => obj.value == global.country);



                       if (_elemIndex > -1)
                       {

                              this.setState({
                                countryOptions: _countryOptions,
                                selectedCountryOption: _countryOptions[_elemIndex]
                              });
                       }
                       else
                       {
                             this.setState({
                               countryOptions: _countryOptions
                             });
                       }

                }
          }
    }






    handleResize = () => {




      let vw;
      if (window.innerWidth > 1400)
      {
        vw = 1230;
      }
      else if (window.innerWidth > 1200)
      {
        vw = 1030;
      }
      else
      {
        vw = 900;
      }

      const videoWidth = vw;

      //console.log('Resiez :: videoWidth >>> ' + videoWidth)

      this.setState({
        videoWidth: videoWidth,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
      });
    }


  goToStepTwo() {
    this.formContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.setState({
      editProfileStep: 2
    });
  }

  backToStepOne() {
    this.formContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.setState({
      editProfileStep: 1,
      profileType: null
    })
  }


  cancelFormFilling() {
    this.backToStepOne();
    this.props.quitStartFillingFormCreative();
  }


  submitForm() {


          if (this.state.profileType === 'Organization')
          {
                     if (this.state.firstName.length === 0 || this.state.lastName.length === 0 || companyName.length === 0 || companySector.length === 0 ||
                             contactRole.length === 0 || selectedSizeOption === null)
                     {
                           this.scrollToRef();

                           this.setState({
                             status: 'error'
                           });
                     }
                     else if (!this.isEmail(this.state.email))
                     {
                           this.setState({
                             status: 'emailerror'
                           });
                           this.scrollToRef();
                    }
                    else if (this.state.phone.length === 0)
                    {
                          this.setState({
                            status: 'error'
                          });
                          this.scrollToRef();
                    }
                    else
                    {
                          this.setState({
                            processing: true
                          });
                          this.sendHTTPRequest();

                    }
          }
          else
          {

                  if (this.state.firstName.length === 0 || this.state.lastName.length === 0 )
                   {
                       this.scrollToRef();

                       this.setState({
                         status: 'error'
                       });
                   }
                   else if (!this.isEmail(this.state.email))
                   {

                       this.setState({
                         status: 'emailerror'
                       });
                       this.scrollToRef();
                  }
                  else if (this.state.phone.length === 0)
                  {
                      this.setState({
                        status: 'error'
                      });
                      this.scrollToRef();
                  }
                  else
                  {
                      this.setState({
                        processing: true
                      });
                      this.sendHTTPRequest();
                  }

        }


  }


  sendHTTPRequest() {

             var ip = 'https://api0.debyoo.com/'; // generateIPForREST();

             let region = this.state.region;
             if (this.state.selectedCountryOption.value === 'CD')
             {
                region = this.state.selectedRegionOption.value;
             }

             let organization_size = '';
             if (this.state.profileCateg === 'Organization' && this.state.selectedSizeOption !== null)
             {
                organization_size = this.state.selectedSizeOption.value;
             }

             // const contributions = this.state.contributions.map(item => item.value);



             let hash = {
               campaign_id: '694ea0c5223ba34102e982d3',
               request_type: 'creatifs',
               product_name: 'mvc',
               product_target: this.state.profileCateg,
               channel: 'www.re-rdc.com',
               platform: 'web',
               user_agent: navigator.userAgent,
               profile_categ: this.state.profileCateg,
               first_name: this.state.firstName,
               last_name: this.state.lastName,
               role: this.state.role,
               email: this.state.email,
               phone: this.state.phone,
               phone_country_code: '243',
               country: this.state.selectedCountryOption.value || '',
               region: region,
               contributions: '',
               infos: this.state.infos,
               organization_name: this.state.companyName,
               organization_size: organization_size,
               lang: i18n.language
             };


             //alert(JSON.stringify(contributions));



             fetch(ip+'submit_rerdc_applic_form_api', {
                    method: 'POST',
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(hash)
                 })
               .then((response) => response.json())
               .then((responseData) => {

                     if (responseData.status === 'success')
                     {
                             this.formContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                             window.scrollTo(0,0);
                             this.setState({
                               processing: false,
                               editProfileStep: 3,
                             });

                             this.createContactpeople(responseData.id);
                             this.sendBONotif(responseData.id);


                             setTimeout(() => {
                               this.cancelFormFilling()
                             }, 15000);

                      }
                      else
                      {
                            this.formContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            window.scrollTo(0,0);
                            this.setState({
                              processing: false,
                              editProfileStep: 4,
                            });

                            setTimeout(() => {
                              this.cancelFormFilling()
                            }, 12000);
                      }



               })
                .catch(function(error) {

                }.bind(this));


  }



  createContactpeople = (id) => {


      var ip = 'https://api1.debyoo.com/'; // generateIPForREST();




      fetch(ip+'add_new_contactpeople_from_request_api', {
             method: 'POST',
             headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
             },
             body: JSON.stringify({
               creation_mode: 'creativerequest',
               app: 'RERDC',
               id: id,
               product_name: 'mvc',
               product_target: this.state.profileCateg,
               first_name: this.state.firstName,
               last_name: this.state.lastName,
               email: this.state.email,
               organization_id: '',
               organization_name: this.state.companyName,
               contact_role: this.state.role,
               country: this.state.selectedCountryOption.value,
               phone: this.state.phone,
               label: '',
               visibility: ''
             })
          })
        .then((response) => response.json())
        .then((responseData) => {



        })
         .catch(function(error) {

         }.bind(this));

   }


  sendBONotif = (id) => {

           var ip = 'https://api2.debyoo.com/'; //generateIPForREST();


           fetch(ip+'send_notif_join_creative_request_api', {
                                   method: 'POST',
                                   headers: {
                                     'Accept': 'application/json',
                                     'Content-Type': 'application/json'
                                   },
                                   body: JSON.stringify({
                                     id: id
                                   })
              })
            .then((response) => response.json())
            .then((responseData) => {
                console.log('>> send_notif_join_creative_request_api >> ' + JSON.stringify(responseData));

            })
             .catch(function(error) {

             }.bind(this));

 }



  get authSubmit() {
    let bool = true;

    if (this.state.firstName.length === 0 || this.state.lastName.length === 0 || this.state.email.length === 0 || !this.isEmail(this.state.email) ||
        this.state.phone.length === 0 || this.state.role.length === 0 || this.state.selectedCountryOption === null)
    {
       bool = false;

    }

    if (this.state.profileCateg === 'Organization' && (this.state.companyName.length === 0 || this.state.selectedSizeOption === null ))
    {
       bool = false;
    }

    if (this.state.selectedCountryOption !== null)
    {
        if (this.state.selectedCountryOption.value === 'CD' && this.state.selectedRegionOption === null)
        {
            bool = false;
        }
        else if (this.state.selectedCountryOption.value !== 'CD' && this.state.region.length === 0)
        {
            bool = false;
        }
    }

    return bool;
  }


   isEmail = (email) =>  {
        return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(email);
   }

   isPhone = (phone) => {

       var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

       return re.test(phone);

   }

   onEmailChange = (e) => {
       this.setState({
         status: ''
       });
   }

   onPhoneChange = (e) => {
     this.setState({
       status: ''
     });
   }

   onFieldChange = (e) => {
     this.setState({
       status: ''
     });
   }

   onChangeContribution = (e, actionMeta) => {


           let array = this.state.contributions;
           if (actionMeta.action === 'select-option')
           {

                  array.push(actionMeta.option);

                  this.setState({
                    status: '',
                    contributions: array
                  });

           }
           else if (actionMeta.action === 'pop-value' || actionMeta.action === 'remove-value')
           {


                  var _elemIndex = array.findIndex(obj => obj.value == actionMeta.removedValue.value);

                 if (_elemIndex > -1)
                 {
                   array.splice(_elemIndex, 1);

                   this.setState({
                     status: '',
                     contributions: array
                   });
                 }
                 else
                 {
                   this.setState({
                     status: '',
                   });
                 }


           }
           else if (actionMeta.action === 'clear')
           {
                this.setState({
                  status: '',
                  contributions: []
                });
           }

   }


   scrollToRef = () => {
      this.formDivRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

   }






   render() {

     const textInputSize = '1.3rem';




    return (
       <div>

             <HeaderPC/>

                <ParallaxProvider>


                    <div ref={this.formContainerRef} style={{backgroundColor: '#fff', width: this.state.viewportWidth+'px'}}>


                             <div style={{clear: 'both', height: '100px'}}/>


                              {/* ====================================   TITRE  ==================================== */}

                             {this.state.editProfileStep !== 3 && this.state.editProfileStep !== 4 &&
                               <div className="page-title-pc"
                                   style={{width: this.state.viewportWidth > 1400 ? this.state.viewportWidth*0.8+'px':this.state.viewportWidth*0.94+'px',
                                           margin:'auto',  paddingBottom: '5px', textAlign: 'center', fontWeight: 'bold', color: '#111', fontWeight: 'bold'}}>
                                   <div>REJOINDRE L'ARMÉE CRÉATIVE</div>
                                   <div className="page-subsubtitle-pc">LES GARDIENS DE LA MÉMOIRE COLLECTIVE CONGOLAISE</div>
                               </div>
                             }
                             {this.state.editProfileStep === 3 &&
                               <div className="page-title-pc"
                                   style={{width: this.state.viewportWidth > 1400 ? this.state.viewportWidth*0.8+'px':this.state.viewportWidth*0.94+'px',
                                           margin:'auto',  paddingBottom: '5px', textAlign: 'center', fontWeight: 'bold', color: 'green', fontWeight: 'bold'}}>
                                   <div>Envoyé avec succès!</div>
                               </div>
                             }

                             {this.state.editProfileStep === 4 &&
                               <div className="page-title-pc"
                                   style={{width: this.state.viewportWidth > 1400 ? this.state.viewportWidth*0.8+'px':this.state.viewportWidth*0.94+'px',
                                           margin:'auto',  paddingBottom: '5px', textAlign: 'center', fontWeight: 'bold', color: '#e86e15', fontWeight: 'bold'}}>
                                   <div>Déjà en cours de traitement.</div>
                               </div>
                             }

                             <div style={{clear: 'both', height: '40px'}}/>


                             {this.state.editProfileStep === 4 &&
                                <div style={{height: '80vh', width: this.state.viewportWidth*0.7+'px', maxWidth: '700px', margin: 'auto'}}>
                                      <View style={{width: '100%', height: '40vh', justifyContent: 'center', alignSelf: 'center'}}>
                                           <View style={{width: '100%', alignSelf: 'center'}}>

                                              <Image source={{uri: '/img/pending_icon.png'}} style={{width: 80, height: 80, alignSelf: 'center'}}/>

                                              {i18n.language == 'en' && <Text style={{fontSize: 25, marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>Your request was successfully submitted.</Text>}
                                              {i18n.language == 'fr' && <Text style={{fontSize: 25,  marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`Nous avons bien reçu votre première demande, actuellement en cours de traitement par notre équipe.`}</Text>}


                                               {i18n.language == 'en' && <Text style={{fontSize: 22,  marginTop: 20, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>A dedicated talent consultant will get back to you shortly.</Text>}
                                               {i18n.language == 'fr' && <Text style={{fontSize: 22,  marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`Inutile de soumettre une nouvelle fois: nous reviendrons vers vous très bientôt.`}</Text>}

                                               {i18n.language == 'fr' && <Text style={{fontSize: 22,  marginTop: 20, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`Merci pour votre patience et pour votre volonté de rejoindre l'Armée Créarive.`}</Text>}

                                            </View>
                                        </View>
                                </div>
                             }


                             {this.state.editProfileStep === 3 &&
                                <div style={{height: '80vh', width: this.state.viewportWidth*0.7+'px', maxWidth: '700px', margin: 'auto'}}>
                                      <View style={{width: '100%', height: '40vh', justifyContent: 'center', alignSelf: 'center'}}>
                                           <View style={{width: '100%', alignSelf: 'center'}}>

                                              <Image source={{uri: '/img/yes_icon_transp.png'}} style={{width: 80, height: 80, alignSelf: 'center'}}/>

                                              {i18n.language == 'en' && <Text style={{fontSize: 25, marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>Your request was successfully submitted.</Text>}
                                              {i18n.language == 'fr' && <Text style={{fontSize: 25,  marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`Merci pour votre engagement.`}</Text>}


                                               {i18n.language == 'en' && <Text style={{fontSize: 22,  marginTop: 20, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>A dedicated talent consultant will get back to you shortly.</Text>}
                                               {i18n.language == 'fr' && <Text style={{fontSize: 22,  marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`Notre équipe vous contactera prochainement pour échanger et explorer ensemble la meilleure manière de contribuer.`}</Text>}

                                               {i18n.language == 'fr' && <Text style={{fontSize: 22,  marginTop: 20, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`En attendant, assurez-vous d’avoir consulté les principes directeurs afin de rester aligné(e) avec la vision du mouvement.`}</Text>}

                                            </View>
                                        </View>
                                </div>
                             }



                             {this.state.editProfileStep === 2 && this.state.profileCateg === 'Organization' &&
                                <div style={{minHeight: '80vh', width: this.state.viewportWidth*0.7+'px', maxWidth: '900px', margin: 'auto'}}>

                                       <div className="motion-h1-sub-pc" style={{color: '#333', textAlign: 'center'}}>{'Etape 2 sur 2'}</div>


                                       <div className="clear-both" style={{height: '20px'}}/>

                                       <div style={{fontSize: '14px', color: '#333', textAlign: 'center'}}><span style={{color: 'red'}}>*</span>:{' Les champs marqués d’un astérisque rouge (*) sont obligatoires.'}</div>



                                       <div ref={this.formDivRef} style={{width: '100%', fontSize: '1.3rem'}}>

                                               <div style={{height: '50px'}}>
                                                   {this.state.status === 'error' &&
                                                       <div style={{width: '100%', textAlign: 'center', color: '#fff', backgroundColor: '#fb0028', borderRadius: '6px'}}>
                                                           <div style={{padding: '10px'}}>
                                                              {i18n.language == 'en' && <span>Please fill in all the required fields.</span>}
                                                              {i18n.language == 'fr' && <span>Veuillez remplir tous les champs obligatoires.</span>}
                                                            </div>
                                                       </div>
                                                    }

                                                    {this.state.status === 'emailerror' &&
                                                       <div style={{width: '100%', textAlign: 'center', color: '#fff', backgroundColor: '#fb0028', borderRadius: '6px'}}>
                                                            <div style={{padding: '10px'}}>
                                                              {i18n.language == 'en' && <span>Please check email format.</span>}
                                                              {i18n.language == 'fr' && <span>Veuillez vérifier le format de l'email.</span>}
                                                           </div>
                                                       </div>
                                                    }

                                                    {this.state.status === 'phoneerror' &&
                                                       <div style={{width: '100%', textAlign: 'center', color: '#fff', backgroundColor: '#fb0028', borderRadius: '6px'}}>
                                                           <div style={{padding: '10px'}}>
                                                              {i18n.language == 'en' && <span>The phone number format is incorrect.</span>}
                                                              {i18n.language == 'fr' && <span>Le format du numéro de téléphone est incorrect.</span>}
                                                           </div>
                                                       </div>
                                                    }
                                               </div>



                                               <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>

                                                   <div style={{width: '48%'}}>
                                                           <div>
                                                              {i18n.language == 'en' && <span>First name<span style={{color: 'red'}}>*</span></span>}
                                                              {i18n.language == 'fr' && <span>Nom de l'organisation<span style={{color: 'red'}}>*</span></span>}
                                                           </div>

                                                           <div style={{marginTop: '3px'}}>
                                                             <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff',  fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                               underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false} autoCapitalize="words"
                                                               onChangeText={(companyName) => this.setState({companyName})} onChange={this.onFieldChange} value={this.state.companyName}/>
                                                            </div>
                                                   </div>

                                                   <div style={{width: '48%'}}>
                                                           <div>
                                                              {i18n.language == 'en' && <span>Last name<span style={{color: 'red'}}>*</span></span>}
                                                              {i18n.language == 'fr' && <span>Taille/Effectif de l’organisation<span style={{color: 'red'}}>*</span></span>}
                                                           </div>

                                                           <div style={{marginTop: '3px'}}>
                                                             <Select styles={customStyles}
                                                               value={this.state.selectedSizeOption}
                                                               onChange={(selectedSizeOption) => this.setState({selectedSizeOption})}
                                                                options={this.state.sizeOptions}
                                                                placeholder={''}
                                                                 isClearable={true}
                                                                  isSearchable={true}
                                                                  placeholder={'Sélectionner'}
                                                                   />
                                                            </div>
                                                   </div>

                                              </div>




                                                <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>

                                                    <div style={{width: '48%'}}>
                                                            <div>
                                                               {i18n.language == 'en' && <span>First name<span style={{color: 'red'}}>*</span></span>}
                                                               {i18n.language == 'fr' && <span>Prénom de la personne de contact<span style={{color: 'red'}}>*</span></span>}
                                                            </div>

                                                            <div style={{marginTop: '3px'}}>
                                                              <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff',  fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                                underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false} autoCapitalize="words"
                                                                onChangeText={(firstName) => this.setState({firstName})} onChange={this.onFieldChange} value={this.state.firstName}/>
                                                             </div>
                                                    </div>

                                                    <div style={{width: '48%'}}>
                                                            <div>
                                                               {i18n.language == 'en' && <span>Last name<span style={{color: 'red'}}>*</span></span>}
                                                               {i18n.language == 'fr' && <span>Nom de famille de la personne de contact<span style={{color: 'red'}}>*</span></span>}
                                                            </div>

                                                            <div style={{marginTop: '3px'}}>
                                                              <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff', fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                                underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false} autoCapitalize="words"
                                                                onChangeText={(lastName) => this.setState({lastName})} onChange={this.onFieldChange} value={this.state.lastName}/>
                                                             </div>
                                                    </div>

                                               </div>


                                               <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>

                                                   <div style={{width: '48%'}}>
                                                           <div>
                                                              {i18n.language == 'en' && <span>Email address<span style={{color: 'red'}}>*</span></span>}
                                                              {i18n.language == 'fr' && <span>Adresse email<span style={{color: 'red'}}>*</span></span>}
                                                           </div>

                                                           <div style={{marginTop: '3px'}}>
                                                             <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff',  fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                               underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false} autoCapitalize="none"
                                                               onChangeText={(email) => this.setState({email})} onChange={this.onFieldChange} value={this.state.email}/>
                                                            </div>
                                                   </div>

                                                   <div style={{width: '48%'}}>
                                                           <div>
                                                              {i18n.language == 'en' && <span>WhatsApp number<span style={{color: 'red'}}>*</span></span>}
                                                              {i18n.language == 'fr' && <span>Numéro WhatsApp<span style={{color: 'red'}}>*</span></span>}
                                                           </div>

                                                           <div style={{marginTop: '3px'}}>
                                                             <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff', fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                               underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false}
                                                               onChangeText={(phone) => this.setState({phone})} onChange={this.onFieldChange} value={this.state.phone}/>
                                                            </div>
                                                   </div>

                                              </div>



                                              <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>

                                                    <div style={{width: '48%'}}>
                                                            <div>
                                                               {i18n.language == 'en' && <span>Country<span style={{color: 'red'}}>*</span></span>}
                                                               {i18n.language == 'fr' && <span>Pays où l’organisation est basée<span style={{color: 'red'}}>*</span></span>}
                                                            </div>

                                                            <div style={{marginTop: '3px'}}>
                                                              <Select styles={customStyles}
                                                                value={this.state.selectedCountryOption}
                                                                onChange={(selectedCountryOption) => this.setState({selectedCountryOption})}
                                                                 options={this.state.countryOptions}
                                                                 menuPlacement="top"
                                                                 placeholder={''}
                                                                  isClearable={true}
                                                                   isSearchable={true}
                                                                   placeholder={'Sélectionner'}
                                                                    />
                                                             </div>
                                                    </div>


                                                  <div style={{width: '48%'}}>
                                                          {this.state.selectedCountryOption !== null && this.state.selectedCountryOption.value === 'CD' &&
                                                            <div>
                                                               {i18n.language == 'en' && <span>WhatsApp number<span style={{color: 'red'}}>*</span></span>}
                                                               {i18n.language == 'fr' && <span>Province où l’organisation est basée<span style={{color: 'red'}}>*</span></span>}
                                                            </div>
                                                          }
                                                          {this.state.selectedCountryOption !== null && (this.state.selectedCountryOption.value === 'US' || this.state.selectedCountryOption.value === 'CA') &&
                                                            <div>
                                                               {i18n.language == 'en' && <span>WhatsApp number<span style={{color: 'red'}}>*</span></span>}
                                                               {i18n.language == 'fr' && <span>Etat où l’organisation est basée<span style={{color: 'red'}}>*</span></span>}
                                                            </div>
                                                          }
                                                          {(this.state.selectedCountryOption === null ||
                                                           (this.state.selectedCountryOption !== null && this.state.selectedCountryOption.value !== 'CD' && this.state.selectedCountryOption.value !== 'US' && this.state.selectedCountryOption.value !== 'CA')) &&
                                                            <div>
                                                               {i18n.language == 'en' && <span>WhatsApp number<span style={{color: 'red'}}>*</span></span>}
                                                               {i18n.language == 'fr' && <span>Ville où l’organisation est basée<span style={{color: 'red'}}>*</span></span>}
                                                            </div>
                                                          }

                                                          {this.state.selectedCountryOption !== null && this.state.selectedCountryOption.value === 'CD' &&
                                                           <div style={{marginTop: '3px'}}>
                                                             <Select styles={customStyles}
                                                              value={this.state.selectedRegionOption}
                                                              onChange={(selectedRegionOption) => this.setState({selectedRegionOption})}
                                                               options={this.state.regionOptions}
                                                               menuPlacement="top"
                                                               placeholder={''}
                                                                isClearable={true}
                                                                 isSearchable={true}
                                                                 placeholder={'Sélectionner'}
                                                                  />
                                                           </div>
                                                          }

                                                          {((this.state.selectedCountryOption !== null && this.state.selectedCountryOption.value !== 'CD') || this.state.selectedCountryOption === null) &&
                                                            <div style={{marginTop: '3px'}}>
                                                               <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff', fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                                 underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false}
                                                                 onChangeText={(region) => this.setState({region})} onChange={this.onFieldChange} value={this.state.region}/>
                                                            </div>
                                                          }
                                                  </div>



                                             </div>





                                             <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>

                                                 <div style={{width: '48%'}}>
                                                         <div>
                                                            {i18n.language == 'en' && <span>Email address<span style={{color: 'red'}}>*</span></span>}
                                                            {i18n.language == 'fr' && <span>Secteur d’activité<span style={{color: 'red'}}>*</span></span>}
                                                         </div>

                                                         <div style={{marginTop: '3px'}}>
                                                           <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff',  fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                             underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false} autoCapitalize="words"
                                                             onChangeText={(role) => this.setState({role})} onChange={this.onFieldChange} value={this.state.role}/>
                                                          </div>
                                                 </div>


                                                 <div style={{width: '48%'}}>

                                                 </div>



                                            </div>

                                            <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>

                                                <div style={{width: '100%'}}>
                                                        <div>
                                                           {i18n.language == 'en' && <span>Email address<span style={{color: 'red'}}>*</span></span>}
                                                           {i18n.language == 'fr' && <span>Souhaitez-vous ajouter quelque chose?</span>}
                                                        </div>
                                                        <div style={{fontSize: '1rem', color: '#777'}}>
                                                           {`(facultatif – tout élément qui pourrait éclairer votre profil ou motivation)`}
                                                        </div>

                                                        <div style={{marginTop: '3px'}}>
                                                          <TextInput style={{width: '100%', textAlignVertical: 'top', color: '#111', background: '#fff',  fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '150px', padding: 6, }}
                                                            underlineColorAndroid='transparent' textAlignVertical='middle' multiline={true} autoComplete="off" autoCorrect={false}
                                                            onChangeText={(infos) => this.setState({infos})} onChange={this.onFieldChange} value={this.state.infos}/>
                                                         </div>
                                                </div>

                                            </div>


                                       </div>








                                       <div className="clear-both" style={{height: '40px'}}/>


                                       <div style={{width: '100%', margin: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>


                                          {!this.state.processing &&
                                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                                  <div onClick={this.backToStepOne.bind(this)} className="blue-button-pc">
                                                     <div>&larr; Etape 1</div>
                                                  </div>

                                                   <div onClick={this.cancelFormFilling.bind(this)} className="cancel-button-pc" style={{marginLeft: '20px'}}>
                                                        <div>Annuler</div>
                                                  </div>
                                            </div>
                                          }

                                          {this.state.processing &&
                                            <div style={{display: 'flex', flexDirection: 'row', opacity: 0.3}}>
                                                  <div className="blue-button-pc" style={{cursor: 'default'}}>
                                                     <div>&larr; Etape 1</div>
                                                  </div>

                                                   <div className="cancel-button-pc" style={{marginLeft: '20px', cursor: 'default'}}>
                                                        <div>Annuler</div>
                                                  </div>
                                             </div>
                                           }




                                           {this.authSubmit && this.state.processing &&
                                              <div onClick={this.submitForm.bind(this)} className="blue-button-pc">
                                                <View style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}><ActivityIndicator  animating={true} color="#fff" /></View>
                                             </div>
                                           }

                                           {this.authSubmit && !this.state.processing &&
                                              <div onClick={this.submitForm.bind(this)} className="blue-button-pc">
                                                <div>Soumettre</div>
                                             </div>
                                           }

                                           {!this.authSubmit &&
                                             <div className="blue-button-disabled-pc">
                                                <div>Soumettre</div>
                                             </div>
                                           }

                                       </div>



                                       <div className="clear-both" style={{height: '250px'}}/>



                                </div>
                            }


                             {this.state.editProfileStep === 2 && this.state.profileCateg === 'Person' &&
                                <div style={{minHeight: '80vh', width: this.state.viewportWidth*0.7+'px', maxWidth: '900px', margin: 'auto'}}>

                                       <div className="motion-h1-sub-pc" style={{color: '#333', textAlign: 'center'}}>{'Etape 2 sur 2'}</div>


                                       <div className="clear-both" style={{height: '20px'}}/>

                                       <div style={{fontSize: '14px', color: '#333', textAlign: 'center'}}><span style={{color: 'red'}}>*</span>:{' Les champs marqués d’un astérisque rouge (*) sont obligatoires.'}</div>


                                       <div ref={this.formDivRef} style={{width: '100%', fontSize: '1.3rem'}}>

                                               <div style={{height: '50px'}}>
                                                   {this.state.status === 'error' &&
                                                       <div style={{width: '100%', textAlign: 'center', color: '#fff', backgroundColor: '#fb0028', borderRadius: '6px'}}>
                                                           <div style={{padding: '10px'}}>
                                                              {i18n.language == 'en' && <span>Please fill in all the required fields.</span>}
                                                              {i18n.language == 'fr' && <span>Veuillez remplir tous les champs obligatoires.</span>}
                                                            </div>
                                                       </div>
                                                    }

                                                    {this.state.status === 'emailerror' &&
                                                       <div style={{width: '100%', textAlign: 'center', color: '#fff', backgroundColor: '#fb0028', borderRadius: '6px'}}>
                                                            <div style={{padding: '10px'}}>
                                                              {i18n.language == 'en' && <span>Please check email format.</span>}
                                                              {i18n.language == 'fr' && <span>Veuillez vérifier le format de l'email.</span>}
                                                           </div>
                                                       </div>
                                                    }

                                                    {this.state.status === 'phoneerror' &&
                                                       <div style={{width: '100%', textAlign: 'center', color: '#fff', backgroundColor: '#fb0028', borderRadius: '6px'}}>
                                                           <div style={{padding: '10px'}}>
                                                              {i18n.language == 'en' && <span>The phone number format is incorrect.</span>}
                                                              {i18n.language == 'fr' && <span>Le format du numéro de téléphone est incorrect.</span>}
                                                           </div>
                                                       </div>
                                                    }
                                               </div>


                                                <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>

                                                    <div style={{width: '48%'}}>
                                                            <div>
                                                               {i18n.language == 'en' && <span>First name<span style={{color: 'red'}}>*</span></span>}
                                                               {i18n.language == 'fr' && <span>Prénom<span style={{color: 'red'}}>*</span></span>}
                                                            </div>

                                                            <div style={{marginTop: '3px'}}>
                                                              <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff',  fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                                underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false} autoCapitalize="words"
                                                                onChangeText={(firstName) => this.setState({firstName})} onChange={this.onFieldChange} value={this.state.firstName}/>
                                                             </div>
                                                    </div>

                                                    <div style={{width: '48%'}}>
                                                            <div>
                                                               {i18n.language == 'en' && <span>Last name<span style={{color: 'red'}}>*</span></span>}
                                                               {i18n.language == 'fr' && <span>Nom de famille<span style={{color: 'red'}}>*</span></span>}
                                                            </div>

                                                            <div style={{marginTop: '3px'}}>
                                                              <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff', fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                                underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false} autoCapitalize="words"
                                                                onChangeText={(lastName) => this.setState({lastName})} onChange={this.onFieldChange} value={this.state.lastName}/>
                                                             </div>
                                                    </div>

                                               </div>


                                               <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>

                                                   <div style={{width: '48%'}}>
                                                           <div>
                                                              {i18n.language == 'en' && <span>Email address<span style={{color: 'red'}}>*</span></span>}
                                                              {i18n.language == 'fr' && <span>Adresse email<span style={{color: 'red'}}>*</span></span>}
                                                           </div>

                                                           <div style={{marginTop: '3px'}}>
                                                             <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff',  fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                               underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false} autoCapitalize="none"
                                                               onChangeText={(email) => this.setState({email})} onChange={this.onFieldChange} value={this.state.email}/>
                                                            </div>
                                                   </div>

                                                   <div style={{width: '48%'}}>
                                                           <div>
                                                              {i18n.language == 'en' && <span>WhatsApp number<span style={{color: 'red'}}>*</span></span>}
                                                              {i18n.language == 'fr' && <span>Numéro WhatsApp<span style={{color: 'red'}}>*</span></span>}
                                                           </div>

                                                           <div style={{marginTop: '3px'}}>
                                                             <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff', fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                               underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false}
                                                               onChangeText={(phone) => this.setState({phone})} onChange={this.onFieldChange} value={this.state.phone}/>
                                                            </div>
                                                   </div>

                                              </div>



                                              <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>

                                                  <div style={{width: '48%'}}>
                                                          <div>
                                                             {i18n.language == 'en' && <span>Country<span style={{color: 'red'}}>*</span></span>}
                                                             {i18n.language == 'fr' && <span>Pays de résidence<span style={{color: 'red'}}>*</span></span>}
                                                          </div>

                                                          <div style={{marginTop: '3px'}}>
                                                            <Select styles={customStyles}
                                                              value={this.state.selectedCountryOption}
                                                              onChange={(selectedCountryOption) => this.setState({selectedCountryOption})}
                                                               options={this.state.countryOptions}
                                                               menuPlacement="top"
                                                               placeholder={''}
                                                                isClearable={true}
                                                                 isSearchable={true}
                                                                 placeholder={'Sélectionner'}
                                                                  />
                                                           </div>
                                                  </div>

                                                  <div style={{width: '48%'}}>
                                                          {this.state.selectedCountryOption !== null && this.state.selectedCountryOption.value === 'CD' &&
                                                            <div>
                                                               {i18n.language == 'en' && <span>WhatsApp number<span style={{color: 'red'}}>*</span></span>}
                                                               {i18n.language == 'fr' && <span>Province de résidence<span style={{color: 'red'}}>*</span></span>}
                                                            </div>
                                                          }
                                                          {this.state.selectedCountryOption !== null && (this.state.selectedCountryOption.value === 'US' || this.state.selectedCountryOption.value === 'CA') &&
                                                            <div>
                                                               {i18n.language == 'en' && <span>WhatsApp number<span style={{color: 'red'}}>*</span></span>}
                                                               {i18n.language == 'fr' && <span>Etat de résidence<span style={{color: 'red'}}>*</span></span>}
                                                            </div>
                                                          }
                                                          {(this.state.selectedCountryOption === null ||
                                                           (this.state.selectedCountryOption !== null && this.state.selectedCountryOption.value !== 'CD' && this.state.selectedCountryOption.value !== 'US' && this.state.selectedCountryOption.value !== 'CA')) &&
                                                            <div>
                                                               {i18n.language == 'en' && <span>WhatsApp number<span style={{color: 'red'}}>*</span></span>}
                                                               {i18n.language == 'fr' && <span>Ville de résidence<span style={{color: 'red'}}>*</span></span>}
                                                            </div>
                                                          }

                                                          {this.state.selectedCountryOption !== null && this.state.selectedCountryOption.value === 'CD' &&
                                                           <div style={{marginTop: '3px'}}>
                                                             <Select styles={customStyles}
                                                              value={this.state.selectedRegionOption}
                                                              onChange={(selectedRegionOption) => this.setState({selectedRegionOption})}
                                                               options={this.state.regionOptions}
                                                               menuPlacement="top"
                                                               placeholder={''}
                                                                isClearable={true}
                                                                 isSearchable={true}
                                                                 placeholder={'Sélectionner'}
                                                                  />
                                                           </div>
                                                          }

                                                          {((this.state.selectedCountryOption !== null && this.state.selectedCountryOption.value !== 'CD') || this.state.selectedCountryOption === null) &&
                                                            <div style={{marginTop: '3px'}}>
                                                               <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff', fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                                 underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false}
                                                                 onChangeText={(region) => this.setState({region})} onChange={this.onFieldChange} value={this.state.region}/>
                                                            </div>
                                                          }
                                                  </div>

                                             </div>


                                             <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>

                                                 <div style={{width: '48%'}}>
                                                         <div>
                                                            {i18n.language == 'en' && <span>Email address<span style={{color: 'red'}}>*</span></span>}
                                                            {i18n.language == 'fr' && <span>Profession ou secteur d’activité<span style={{color: 'red'}}>*</span></span>}
                                                         </div>

                                                         <div style={{marginTop: '3px'}}>
                                                           <TextInput style={{width: '100%', textAlignVertical: 'middle', color: '#111', background: '#fff',  fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '50px', padding: 6, }}
                                                             underlineColorAndroid='transparent' textAlignVertical='middle' multiline={false} autoComplete="off" autoCorrect={false} autoCapitalize="words"
                                                             onChangeText={(role) => this.setState({role})} onChange={this.onFieldChange} value={this.state.role}/>
                                                          </div>
                                                 </div>

                                                 <div style={{width: '48%', display: 'none'}}>
                                                         <div>
                                                            {i18n.language == 'en' && <span>WhatsApp number<span style={{color: 'red'}}>*</span></span>}
                                                            {i18n.language == 'fr' && <span>Que pouvez-vous apporter?<span style={{color: 'red'}}>*</span></span>}
                                                         </div>

                                                         <div style={{marginTop: '3px'}}>
                                                              <Select
                                                                  defaultValue={this.state.contributions}
                                                                  isMulti
                                                                  menuPlacement="top"
                                                                  onChange={this.onChangeContribution}
                                                                  options={this.state.contributionOptions}
                                                                  styles={{
                                                                    control: (provided) => ({
                                                                      ...provided,
                                                                      minHeight: '50px',      // set your desired height
                                                                    }),
                                                                    multiValue: (styles, { data }) => {
                                                                      return {
                                                                        ...styles,
                                                                        backgroundColor: '#dee9f9',
                                                                      };
                                                                    },
                                                                    multiValueLabel: (styles, { data }) => ({
                                                                      ...styles,
                                                                      color: '#0c3fc2',
                                                                    }),
                                                                    multiValueRemove: (styles, { data }) => ({
                                                                      ...styles,
                                                                      color: '#0639c1',
                                                                      ':hover': {
                                                                        backgroundColor: '#0639c1',
                                                                        color: '#fff',
                                                                      },
                                                                    }),
                                                                  }}
                                                                  placeholder={'Sélectionner ou saisir...'}
                                                                     />
                                                          </div>
                                                 </div>

                                            </div>

                                            <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>

                                                <div style={{width: '100%'}}>
                                                        <div>
                                                           {i18n.language == 'en' && <span>Email address<span style={{color: 'red'}}>*</span></span>}
                                                           {i18n.language == 'fr' && <span>Souhaitez-vous ajouter quelque chose?</span>}
                                                        </div>
                                                        <div style={{fontSize: '1rem', color: '#777'}}>
                                                           {`(facultatif – tout élément qui pourrait éclairer votre profil ou motivation)`}
                                                        </div>

                                                        <div style={{marginTop: '3px'}}>
                                                          <TextInput style={{width: '100%', textAlignVertical: 'top', color: '#111', background: '#fff',  fontSize: textInputSize, border: '1px solid #ccc', borderRadius: '4px',textAlign:'left', height: '150px', padding: 6, }}
                                                            underlineColorAndroid='transparent' textAlignVertical='middle' multiline={true} autoComplete="off" autoCorrect={false}
                                                            onChangeText={(infos) => this.setState({infos})} onChange={this.onFieldChange} value={this.state.infos}/>
                                                         </div>
                                                </div>

                                            </div>


                                       </div>








                                       <div className="clear-both" style={{height: '40px'}}/>


                                       <div style={{width: '100%', margin: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>


                                          {!this.state.processing &&
                                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                                  <div onClick={this.backToStepOne.bind(this)} className="blue-button-pc">
                                                     <div>&larr; Etape 1</div>
                                                  </div>

                                                   <div onClick={this.cancelFormFilling.bind(this)} className="cancel-button-pc" style={{marginLeft: '20px'}}>
                                                        <div>Annuler</div>
                                                  </div>
                                            </div>
                                          }

                                          {this.state.processing &&
                                            <div style={{display: 'flex', flexDirection: 'row', opacity: 0.3}}>
                                                  <div className="blue-button-pc" style={{cursor: 'default'}}>
                                                     <div>&larr; Etape 1</div>
                                                  </div>

                                                   <div className="cancel-button-pc" style={{marginLeft: '20px', cursor: 'default'}}>
                                                        <div>Annuler</div>
                                                  </div>
                                             </div>
                                           }




                                           {this.authSubmit && this.state.processing &&
                                              <div onClick={this.submitForm.bind(this)} className="blue-button-pc">
                                                <View style={{width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}><ActivityIndicator  animating={true} color="#fff" /></View>
                                             </div>
                                           }

                                           {this.authSubmit && !this.state.processing &&
                                              <div onClick={this.submitForm.bind(this)} className="blue-button-pc">
                                                <div>Soumettre</div>
                                             </div>
                                           }

                                           {!this.authSubmit &&
                                             <div className="blue-button-disabled-pc">
                                                <div>Soumettre</div>
                                             </div>
                                           }

                                       </div>



                                       <div className="clear-both" style={{height: '250px'}}/>



                                </div>
                            }



                             {this.state.editProfileStep === 1 &&
                                <div style={{height: '80vh', width: this.state.viewportWidth*0.7+'px', maxWidth: '900px', margin: 'auto'}}>

                                       <div className="motion-h1-sub-pc" style={{color: '#333', textAlign: 'center'}}>{'Etape 1 sur 2'}</div>


                                        <div className="clear-both" style={{height: '40px'}}/>

                                        <div className="page-subsubtitle-pc" style={{color: '#333', textAlign: 'center'}}>{`Rejoignez-vous en tant qu’individu ou au nom d’une organisation ?`}</div>

                                        <div className="clear-both" style={{height: '50px'}}/>


                                        <div style={{width: '100%', margin: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>

                                            <div onClick={() => this.setState({profileCateg: 'Person'})}
                                                 style={{position: 'relative', cursor: 'pointer', width: '48%', height: '170px', backgroundColor: '#fff',
                                                        borderRadius: '6px', border: this.state.profileCateg === 'Person' ? '2px solid #609b35' : '1px solid #ccc'}}>

                                                   <div className="motion-h1-sub-pc" style={{fontWeight: 'bold', color: '#111', textAlign: 'center', marginTop: '50px'}}>Individu</div>
                                                   <div style={{fontSize: '17px', color: '#777', textAlign: 'center', marginTop: '5px'}}>(Personne physique)</div>

                                                   {this.state.profileCateg === 'Person' && <img src={'/img/yes_icon_transp.png'} style={{width: '50px', height: '50px', position: 'absolute', zIndex: 3, top: '5px', right: '5px'}}/>}

                                            </div>

                                            <div onClick={() => this.setState({profileCateg: 'Organization', contributionOptions})}
                                                 style={{position: 'relative', cursor: 'pointer', width: '48%', height: '170px', backgroundColor: '#fff',
                                                        borderRadius: '6px', border: this.state.profileCateg === 'Organization' ? '2px solid #609b35' : '1px solid #ccc'}}>


                                                  <div className="motion-h1-sub-pc" style={{fontWeight: 'bold', color: '#111', textAlign: 'center', marginTop: '50px'}}>Organisation</div>
                                                  <div style={{fontSize: '17px', color: '#777', textAlign: 'center', marginTop: '5px'}}>(entreprises, institution, association, collectif...)</div>

                                                  {this.state.profileCateg === 'Organization' && <img src={'/img/yes_icon_transp.png'} style={{width: '50px', height: '50px', position: 'absolute', zIndex: 3, top: '5px', right: '5px'}}/>}

                                            </div>

                                        </div>

                                        <div className="clear-both" style={{height: '40px'}}/>

                                        <div style={{width: '100%', margin: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>


                                            <div onClick={this.cancelFormFilling.bind(this)} className="cancel-button-pc">
                                                 <div>Annuler</div>
                                           </div>




                                            {this.state.profileCateg !== null &&
                                               <div onClick={this.goToStepTwo.bind(this)} className="blue-button-pc">
                                                 <div>Etape 2 &rarr;</div>
                                              </div>
                                            }

                                            {this.state.profileCateg === null &&
                                              <div className="blue-button-disabled-pc">
                                                 <div>Etape 2 &rarr;</div>
                                              </div>
                                            }

                                        </div>


                              </div>
                            }



                </div>





                <div style={{clear: 'both', height: '40px'}}/>





       </ParallaxProvider>
    </div>

    )
  }
}


  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '52px',      // set your desired height
      height: '52px',         // optional: forces the height
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '52px',
      padding: '0 8px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '52px',
    }),
  };




  export default OpenJobFormPCCreative;
